import getCookieValue from "./getCookieValue";
import selector from "./selector";
import { log } from "./logger";
export default async function getPrice() {
    window.products = [];
    let controller = new AbortController();
    let timeout = setTimeout(() => {
        controller.abort();
    }, 40000);
    window.products = (await (await findProds(controller)).json()).data;
    clearTimeout(timeout);
}
function formatFloatStringToGerNumber(value) {
    return Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR", currencyDisplay: "code" }).format(Number.parseFloat(value)).replace("EUR", "").trim();
}
function calculateStrompreisbremse(arbeitspreis, grundpreis) {
    return ((((Number.parseInt(String(getUsageElement()?.val())) * (Number.parseFloat(arbeitspreis) / 100)) + (12 * Number.parseFloat(grundpreis))) - (((Number.parseFloat(arbeitspreis) / 100) - 0.4) * (Number.parseInt(String(getUsageElement()?.val())) * 0.8))) / 12).toFixed(0);
}
export async function getErrorResult(errorcode = "0") {
    try {
        //@ts-ignore
        return await ((await fetch(`${warp_berlin_tarifrechner.js_url}vendor/tarifrechner/parts/result-error.php?error_content=${errorcode}`, {
            method: "GET"
        })).text());
    }
    catch (ex) {
        console.error(ex);
        throw ex;
    }
}
export async function showError(errorcode) {
    //@ts-ignore
    if (!window.errors.includes(errorcode)) {
        //@ts-ignore
        window.errors.push(errorcode);
        jQuery(selector.TarifrechnerResult).append(await buildError(errorcode));
        jQuery(selector.TarifrechnerResult).slideDown();
    }
}
export async function buildError(errorcode) {
    let div = document.createElement("div");
    div.innerHTML = await getErrorResult(errorcode);
    div.setAttribute("data-errorcode", errorcode);
    return div;
}
export async function getFinePrint(strompreisbremse) {
    try {
        var usage = String(Number.parseInt(String(getUsageElement()?.val())));
        //@ts-ignore
        return await ((await fetch(`${warp_berlin_tarifrechner.js_url}vendor/tarifrechner/parts/result-fineprint.php?${strompreisbremse ? `&strompreisbremse=${strompreisbremse}` : ""}&kwh=${new Intl.NumberFormat('de-DE').format(usage)}`, {
            method: "GET"
        })).text());
    }
    catch (ex) {
        console.error(ex);
        throw ex;
    }
}
export function addTooltipHandler(product) {
    jQuery(selector.DataAllyDialogShow(product.ProductName)).children("svg").each((index, element) => {
        jQuery(element).on("click", (e) => {
            jQuery(selector.DataAllyDialog(product.ProductName)).slideDown();
        });
    });
    jQuery(selector.DataAllyDialog(product.ProductName)).find("button").each((index, element) => {
        jQuery(element).on("click", (e) => {
            jQuery(selector.DataAllyDialog(product.ProductName)).slideUp();
        });
    });
}
export function getUsageElement() {
    var usage;
    //@ts-ignore
    switch (window.mode) {
        case "gewerbe":
            usage = jQuery("#gewerbe_tarif_kwh");
            break;
        case "privat":
            usage = jQuery("#privat_tarif_kwh");
            break;
        case "waermepumpe":
            usage = jQuery("#waermepumpe_tarif_kwh");
            break;
        case "mieterstrom":
            usage = jQuery("#mieterstrom_tarif_kwh");
            break;
        default:
            break;
    }
    return usage;
}
export function addJumpOffHandler(product) {
    log(`registering on: ${selector.AssignedProductButton(product.ProductName)}`);
    log(product.ProductName);
    jQuery(selector.AssignedProductButton(product.ProductName)).on("click", (e) => {
        log("founc click");
        e.preventDefault();
        var usage;
        var plz;
        var city;
        //@ts-ignore
        switch (window.mode) {
            case "gewerbe":
                usage = Number.parseInt(String(jQuery("#gewerbe_tarif_kwh").val()));
                plz = Number.parseInt(String(jQuery("#gewerbe_tarif_plz").val()).split(", ")[0]);
                city = String(jQuery("#gewerbe_tarif_plz").val()).split(", ")[1];
                break;
            case "privat":
                usage = Number.parseInt(String(jQuery("#privat_tarif_kwh").val()));
                plz = Number.parseInt(String(jQuery("#privat_tarif_plz").val()).split(", ")[0]);
                city = String(jQuery("#privat_tarif_plz").val()).split(", ")[1];
                break;
            case "waermepumpe":
                usage = Number.parseInt(String(jQuery("#waermepumpe_tarif_kwh").val()));
                plz = Number.parseInt(String(jQuery("#waermepumpe_tarif_plz").val()).split(", ")[0]);
                city = String(jQuery("#waermepumpe_tarif_plz").val()).split(", ")[1];
                break;
            case "mieterstrom":
                usage = Number.parseInt(String(jQuery("#mieterstrom_tarif_kwh").val()));
                plz = Number.parseInt(String(jQuery("#mieterstrom_tarif_plz").val()).split(", ")[0]);
                city = String(jQuery("#mieterstrom_tarif_plz").val()).split(", ")[1];
                break;
            default:
                break;
        }
        let _ = {
            product: window.btoa(encodeURIComponent(JSON.stringify(product))),
            usage: usage,
            postcode: plz,
            city: city,
            street: String(jQuery(selector.STREET).first().val()),
            houseNumber: String(jQuery(selector.NUMBER).first().val()),
            business: window.business,
            //@ts-ignore
            crc: window.url_recommendation,
            //@ts-ignore
            iv: window.iv,
            cookie: getCookieValue("portal_companion_cookie")
        };
        let url;
        const urlParams = new URLSearchParams(window.location.search);
        url =
            `https://${window.location.toString().includes("berlinerstadtwerke.de") ? 'auftrag.berlinerstadtwerke.de' : urlParams.get("dotnet") != null ? 'bswdotnet.staging.test.trojahn-horse.de' : 'bsw.staging.test.trojahn-horse.de'}/?token=` +
                window.btoa(JSON.stringify(_));
        window.location.replace(url);
    });
}
export async function generateProductPage(product, strompreisbremse) {
    //https://auftrieb.stadtwerke.dev/app/plugins/warp-berlin-tarifrechner/vendor/tarifrechner/parts/result-single.php
    /**
     *
     */
    let tarifname = product.ProductName;
    let tarifname_voll = product.Product;
    let plz = String(jQuery(selector.PLZ).val());
    let ort = String(jQuery(selector.CITY).val());
    let kwh = String(Number.parseInt(String(getUsageElement()?.val()))).trim();
    let arbeitspreis = formatFloatStringToGerNumber(product.ArbeitsPreis);
    let grundpreis = formatFloatStringToGerNumber(product.GrundPreis);
    let gesamtpreis = formatFloatStringToGerNumber(product.Gesamtpreis);
    let mindestlaufzeit = product.initialDuration;
    let mindestlaufzeit_unit = (product.initialDuration > 1 ? "%20Monate" : "%20Monat");
    let kuendigungsfrist = product.Kuendigungsfrist;
    let kuendigungsfrist_unit = (product.Kuendigungsfrist > 1 ? "%20Monate" : "%20Monat");
    let energiepreisgarantie = product.fixedPriceDate;
    let co2_ersparnis = Math.round(Number.parseInt(String(getUsageElement()?.val())) * 0.324);
    let abschlag_monat_strompreisbremse = calculateStrompreisbremse(arbeitspreis, grundpreis);
    let abschlag_monat = product.deposit;
    let entlastungsbetrag_strompreisbremse = (Number.parseInt(product.deposit) - Number.parseInt(abschlag_monat_strompreisbremse)).toString();
    let business = window.business;
    try {
        log("trigger generateProductPage");
        log(JSON.stringify(product));
        //@ts-ignore
        let document = await ((await fetch(`${warp_berlin_tarifrechner.js_url}vendor/tarifrechner/parts/result-single.php?mindestlaufzeit_unit=${mindestlaufzeit_unit}&kuendigungsfrist_unit=${kuendigungsfrist_unit}&detailURL=${encodeURI(product.detailURL)}&tarifname=${tarifname}&tarifname_voll=${tarifname_voll}&plz=${plz}&ort=${ort}&kwh=${kwh}&arbeitspreis=${arbeitspreis}&grundpreis=${grundpreis}&gesamtpreis=${gesamtpreis}&mindestlaufzeit=${mindestlaufzeit}&kuendigungsfrist=${kuendigungsfrist}&energiepreisgarantie=${energiepreisgarantie}&co2_ersparnis=${co2_ersparnis}${strompreisbremse != "false" ? `&strompreisbremse=${strompreisbremse}` : ""}&abschlag_monat_strompreisbremse=${abschlag_monat_strompreisbremse}&abschlag_monat=${abschlag_monat}&entlastungsbetrag_strompreisbremse=${entlastungsbetrag_strompreisbremse}&gewerbe=${business}`, {
            method: "GET"
        })).text());
        return document;
    }
    catch (ex) {
        console.error(ex);
        throw ex;
    }
}
export function clearResult() {
    //@ts-ignore
    window.errors = [];
    jQuery(selector.TarifrechnerResult).slideUp('fast', () => {
        jQuery(selector.TarifrechnerResult).empty();
    });
    jQuery(selector.TarifrechnerFinePrint).slideUp();
}
export async function getProductTooltip(product, strompreisbremse) {
    let tarifname = product.ProductName;
    let tarifname_voll = product.ProductCode;
    let plz = String(jQuery(selector.PLZ).val());
    let ort = String(jQuery(selector.CITY).val());
    let kwh = String(Number.parseInt(String(getUsageElement()?.val()))).trim();
    let arbeitspreis = formatFloatStringToGerNumber(product.ArbeitsPreis);
    let grundpreis = formatFloatStringToGerNumber(product.GrundPreis);
    let gesamtpreis = formatFloatStringToGerNumber(product.Gesamtpreis);
    let mindestlaufzeit = product.initialDuration;
    let mindestlaufzeit_unit = (product.initialDuration > 1 ? "%20Monate" : "%20Monat");
    let kuendigungsfrist = product.Kuendigungsfrist;
    let kuendigungsfrist_unit = (product.Kuendigungsfrist > 1 ? "%20Monate" : "%20Monat");
    let energiepreisgarantie = product.fixedPriceDate;
    let co2_ersparnis = Math.round(Number.parseInt(String(getUsageElement()?.val())) * 0.324);
    let abschlag_monat_strompreisbremse = calculateStrompreisbremse(arbeitspreis, grundpreis);
    let abschlag_monat = product.deposit;
    let entlastungsbetrag_strompreisbremse = (Number.parseInt(product.deposit) - Number.parseInt(abschlag_monat_strompreisbremse)).toString();
    try {
        log("trigger generateProductPage");
        log(JSON.stringify(product));
        //@ts-ignore
        let document = await ((await fetch(`${warp_berlin_tarifrechner.js_url}vendor/tarifrechner/parts/result-strompreisbremse-dialog.php?mindestlaufzeit_unit=${mindestlaufzeit_unit}&kuendigungsfrist_unit=${kuendigungsfrist_unit}&detailURL=${encodeURI(product.detailURL)}&tarifname=${tarifname}&tarifname_voll=${tarifname_voll}&plz=${plz}&ort=${ort}&kwh=${kwh}&arbeitspreis=${arbeitspreis}&grundpreis=${grundpreis}&gesamtpreis=${gesamtpreis}&mindestlaufzeit=${mindestlaufzeit}&kuendigungsfrist=${kuendigungsfrist}&energiepreisgarantie=${energiepreisgarantie}&co2_ersparnis=${co2_ersparnis}${strompreisbremse != "false" ? `&strompreisbremse=${strompreisbremse}` : ""}&abschlag_monat_strompreisbremse=${abschlag_monat_strompreisbremse}&abschlag_monat=${abschlag_monat}&entlastungsbetrag_strompreisbremse=${entlastungsbetrag_strompreisbremse}`, {
            method: "GET"
        })).text());
        return document;
    }
    catch (ex) {
        console.error(ex);
        throw ex;
    }
}
async function findProds(controller) {
    //https://bsw.staging.test.trojahn-horse.de/products?postCode=
    if (Number.isNaN(window.ccitycode)) {
        jQuery(selector.PLZ).trigger("change");
    }
    var street = String(jQuery(selector.STREET).first().val());
    var houseNumber = String(jQuery(selector.NUMBER).first().val());
    var usage;
    var plz;
    //@ts-ignore
    switch (window.mode) {
        case "gewerbe":
            usage = Number.parseInt(String(jQuery("#gewerbe_tarif_kwh").val()));
            plz = Number.parseInt(String(jQuery("#gewerbe_tarif_plz").val()).split(", ")[0]);
            break;
        case "privat":
            usage = Number.parseInt(String(jQuery("#privat_tarif_kwh").val()));
            plz = Number.parseInt(String(jQuery("#privat_tarif_plz").val()).split(", ")[0]);
            break;
        case "waermepumpe":
            usage = Number.parseInt(String(jQuery("#waermepumpe_tarif_kwh").val()));
            plz = Number.parseInt(String(jQuery("#waermepumpe_tarif_plz").val()).split(", ")[0]);
            break;
        case "mieterstrom":
            usage = Number.parseInt(String(jQuery("#mieterstrom_tarif_kwh").val()));
            plz = Number.parseInt(String(jQuery("#mieterstrom_tarif_plz").val()).split(", ")[0]);
            break;
        default:
            return;
    }
    var prods = await fetch(`${window.location.href.includes("stadtwerke.dev")
        ? `https://bsw.staging.test.trojahn-horse.de/products?postCode=${plz}${jQuery(selector.STREET).is(":visible")
            ? `&street=${street.trim()}`
            : ""}${jQuery(selector.STREET).is(":visible")
            ? `&houseNumber=${houseNumber.trim().replace(" ", "").toLowerCase()}`
            : ""}${window.business ? '&business=true' : ''}${window.waermepumpe ? '&waermepumpe=true' : ''}`
        : `https://auftrag.berlinerstadtwerke.de/products?postCode=${plz}${jQuery(selector.STREET).is(":visible")
            ? `&street=${street.trim()}`
            : ""}${jQuery(selector.STREET).is(":visible")
            ? `&houseNumber=${houseNumber.trim().replace(" ", "").toLowerCase()}`
            : ""}${window.business ? '&business=true' : ''}${window.waermepumpe ? '&waermepumpe=true' : ''}`}`, {
        method: "GET",
        signal: controller.signal,
        headers: {
            cityid: String(window.ccitycode),
            usage: usage !== undefined ? String(usage) : "0",
            "Cache-Control": "no-store",
        },
    });
    return prods;
}
